import sForms from './s-forms'

const sFormsCDN = () => {
  document.addEventListener('DOMContentLoaded', () => {
    sForms()
  }, false)
}

export default sFormsCDN()
